import type { Constants } from "api/generated/model";

import constantsJson from "../constants.json";

export const CONSTANTS: Constants = constantsJson;
